/**
 * @generated SignedSource<<dc82db0e726f374db3bab83889f6a857>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ShareOptionsPanel_catalogPage$data = {
  readonly title: string | null;
  readonly " $fragmentType": "ShareOptionsPanel_catalogPage";
};
export type ShareOptionsPanel_catalogPage$key = {
  readonly " $data"?: ShareOptionsPanel_catalogPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"ShareOptionsPanel_catalogPage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ShareOptionsPanel_catalogPage",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    }
  ],
  "type": "CatalogPage",
  "abstractKey": null
};

(node as any).hash = "c3627c25de72db13169514dfbe62d9eb";

export default node;
